import styled from 'styled-components';

export const ToastControlStyled = styled.div`
  .blue-box {
    background: ${(props) => props.theme.blue.iconBg};
    border-radius: 8px;
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
  }
  .grey-text {
    font-size: 14px;
    color: ${(props) => props.theme.text.medium};
  }
  .close {
    width: 18px;
    height: 18px;
    cursor: pointer;
    position: absolute;
    top: 17px;
    right: 16px;
  }
  .red-box {
    background: ${(props) => props.theme.verification.red.main}12;
    border-radius: 8px;
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: flex-start;
    &.font-14 {
      font-size: 14px;
    }
    .text {
      color: ${(props) => props.theme.verification.red.main};
    }
    .img-wrapper {
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
  }
  .small-text {
    font-size: 14px;
  }
  .green-box {
    background: ${(props) => props.theme.green.off};
    border-radius: 8px;
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
    .text {
      color: ${(props) => props.theme.green.dark};
    }
  }
  .red-dark-box {
    background: ${(props) => props.theme.verification.red.main};
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: flex-start;
    &.font-14 {
      font-size: 14px;
    }
    .text {
      color: ${(props) => props.theme.color.white};
    }
    .img-wrapper {
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
    &.floating-wrapper {
      position: fixed;
      width: 100%;
      z-index: 1100;
      top: 115px;
      justify-content: center;
      &.inSidebar {
        width: 450px;
        max-width: 100%;
        top: 88px;
        right: 0;
      }
    }
  }
  .newVariantGreen {
    background: ${(props) => props?.theme?.green?.milkyGreen};
    border-bottom: 1px solid ${(props) => props?.theme?.green?.light};
    padding: 16px 15px;
    font-weight: 500;
    font-size: 15px;
    position: relative;
    z-index: 150px;
    display: flex;
    align-items: flex-start;

    &.dismissible {
      padding-right: 44px;
    }

    .text {
      color: ${(props) => props?.theme?.color?.dark};
    }
    .img-wrapper {
      margin-top: 2px;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
    &.floating-wrapper {
      position: fixed;
      width: 100%;
      z-index: 150;
      top: 115px;
      justify-content: center;
      &.inSidebar {
        width: 450px;
        max-width: 100%;
        top: 88px;
        right: 0;
      }
    }
  }
  &.topBarDeals {
    .newVariantGreen {
      position: absolute;
      top: 60px;
    }
  }
  .green-dark-box {
    background: ${(props) => props.theme.green.light};
    padding: 16px 15px;
    font-weight: 600;
    font-size: ${(props) => (!props?.PromotionalCart ? '16px' : '15px')};
    display: flex;
    align-items: center;
    height: 50px;
    width: 1366px;
    position: fixed;
    top:0;
    left: 0;
    justify-content: center;
    &.floating-wrapper {
      width: 100%;
      z-index: 1100;
      top: 118px;
      height: 50px;
    }
    &.inSidebar {
      width: 100%;
      right: 0;
    }
    .img-wrapper {
      width: ${(props) => (!props?.PromotionalCart ? '28.000001907348633px' : '23px')};
      height: 28.000001907348633px;
      display: flex;
      align-items: center;
    }
    .text {
      height: 19px;
      font-family: Mulish;
      font-size: 15px;
      font-weight: 700;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      color: ${(props) => props.theme.color.white};
    }
  }
  

  .yellow-dark-box {
    background: ${(props) => props.theme.yellow.off};
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    .text {
      color: ${(props) => props.theme.mandalay.dark};
    }
    .img-wrapper {
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
    &.floating-wrapper {
      position: fixed;
      width: 100%;
      z-index: 1100;
      top: 115px;
      justify-content: center;
      &.inSidebar {
        width: 450px;
        max-width: 100%;
        top: 88px;
        right: 0;
      }
    }
  }

  .e-pharmacy-green-box {
    background: ${(props) => props.theme.grey.greyF4};
    border-radius: 7.5px;
    padding: 16px 15px;
    font-weight: 600;
    font-size: 16px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    border: 1px solid ${(props) => props.theme.green.medium};
    .text {
      font-size: 15px;
      font-weight: 400;
      line-height: 19px;
    }
    .img-wrapper {
      margin-right: 16px;

      > div {
        width: 29.28px;
        height: 28px;
      }
    }
  }

  &.fixed {
    .newVariantGreen {
      &.floating-wrapper {
        top: 80px;
      }
    }
    .green-dark-box {
      &.floating-wrapper {
        top: 80px;
      }
    }
    .yellow-dark-box {
      &.floating-wrapper {
        top: 80px;
      }
    }
  }
   
  .toastControlError{
    background: ${(props) => props.theme.verification.red.main};
  }

  @media (max-width: 768px) {
    &.fixed {
      .newVariantGreen {
        &.floating-wrapper {
          top: 130px;
        }
      }
      &.topBarDeals {
        .newVariantGreen {
          position: fixed !important;
          top: 0 !important;
        }
      }
    }
  }
`;
